import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { class: "user-right" }
const _hoisted_4 = { class: "user" }
const _hoisted_5 = { class: "profile" }
const _hoisted_6 = { class: "email" }
const _hoisted_7 = { class: "role" }

export function render(_ctx, _cache) {
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_affix = _resolveComponent("el-affix")
  const _component_el_avatar = _resolveComponent("el-avatar")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_affix, { offset: 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "logo",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onLogoClick && _ctx.onLogoClick(...args)))
          }, [
            _createVNode(_component_el_image, { src: "/img/ddg-logo-64.png" })
          ]),
          _createElementVNode("div", {
            class: _normalizeClass('logo-line' + ((_ctx.windowWidth < 768) ? '-mobile' : ''))
          }, " MC.health ", 2)
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "el-fade-in" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_dropdown, {
              trigger: "click",
              teleported: false
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, { class: "user-menu" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { onClick: _ctx.onUserProfileClick }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_el_avatar, {
                            size: 50,
                            src: "/img/avatar.png"
                          }),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.userEmail), 1),
                          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.roleName), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_dropdown_item, {
                      divided: "",
                      onClick: _ctx.onMessagesClick,
                      disabled: ""
                    }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createElementVNode("div", { class: "messages" }, "Nachrichten", -1)
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_dropdown_item, {
                      divided: "",
                      onClick: _ctx.onManualClick
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createElementVNode("div", { class: "manual" }, "Benutzerhandbuch", -1)
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_dropdown_item, {
                      divided: "",
                      onClick: _ctx.onSettingsClick,
                      disabled: ""
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createElementVNode("div", { class: "settings" }, "Einstellungen", -1)
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_dropdown_item, {
                      divided: "",
                      onClick: _ctx.onSupportClick,
                      disabled: ""
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createElementVNode("div", { class: "supprot" }, "Support", -1)
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_dropdown_item, {
                      divided: "",
                      onClick: _ctx.onLogoutClick
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createElementVNode("div", { class: "logout" }, "Abmelden", -1)
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.username), 1)
              ]),
              _: 1
            })
          ])
        ], 512), [
          [_vShow, _ctx.showUser]
        ])
      ]),
      _: 1
    })
  ], 64))
}